import {Injectable} from "@angular/core";



@Injectable({providedIn: 'root'})
export class PanelVisibilityService {

  panelUnvisibilities:any

   constructor(){
	this.panelUnvisibilities = localStorage.getItem('panelUnvisibilities')
	this.panelUnvisibilities = this.panelUnvisibilities ? JSON.parse(this.panelUnvisibilities) : {}
   }

 
  isUnvisible(state){

  	return this.panelUnvisibilities[state] === undefined ? false : this.panelUnvisibilities[state]
		
  } 
   getState(state){

  	return this.panelUnvisibilities[state] 
		
  } 
   toggleVisibility(panel){

	let state = this.getState(panel)
	let states : any = localStorage.getItem('panelUnvisibilities') 
	if(states){ states = JSON.parse(states)  } else { states = {} }
	 
        states[panel] = state === undefined ? true : !state;
        this.panelUnvisibilities[panel] = states[panel]
	localStorage.setItem('panelUnvisibilities', JSON.stringify( states )) 
  }


}
